import { useLocalStorage } from '@vueuse/core'

import type { DisciplineInfo } from '@brighterly/lib-core-types/discipline/interfaces'
import type { KidStore } from './interfaces'
import type { ScopeMode } from '@shared/lib/scope'

import { beginEntry, failEntry, settleEntry } from '@shared/lib/scope'

import { createInitialState } from './state'

const STORAGE_KEY = 'active_kid_id'

const persist = (state: KidStore): void => {
  const ls = useLocalStorage<number | null>(STORAGE_KEY, null)
  ls.value = state.activeKidId !== null ? Number(state.activeKidId) : null
}

const setActiveKid = (state: KidStore, id: number): void => {
  state.activeKidId = id
  persist(state)
}

const clear = (state: KidStore): void => {
  state.activeKidId = null
  persist(state)
}

export const actions = {
  resetState (this: KidStore): void {
    Object.assign(this, createInitialState())
  },
  hydrateFromStorage (this: KidStore): void {
    if (this._hydrated) return
    if (this.activeKidId !== null) return

    const ls = useLocalStorage<number | null>(STORAGE_KEY, null)

    this.activeKidId = ls.value !== null ? Number(ls.value) : null
    this._hydrated = true
  },
  persist (this: KidStore): void {
    return persist(this)
  },
  setActiveKid (this: KidStore, id: number): void {
    return setActiveKid(this, id)
  },
  clear (this: KidStore): void {
    return clear(this)
  },
  beginDisciplines (this: KidStore, kidId: number, mode: ScopeMode): number {
    return beginEntry(this.disciplinesByKid, kidId, mode)
  },
  settleDisciplines (this: KidStore, kidId: number, requestId: number, data: DisciplineInfo[]): void {
    settleEntry(this.disciplinesByKid, kidId, requestId, data)
  },
  failDisciplines (this: KidStore, kidId: number, requestId: number): void {
    failEntry(this.disciplinesByKid, kidId, requestId)
  },
}
